import { z } from 'zod';
/**
 * Zdilene primitivy API kontraktu (krok 11). Zod je JEDINY zdroj: z techto
 * schemat vznika validace na API i OpenAPI dokument (a tim i generovany
 * klient). Penize NIKDY number - vzdy numeric string + ISO 4217 (CLAUDE.md 3).
 */
/** Interni ID - UUIDv7 z @reos/ids. */
export const idSchema = z.uuid();
/** Verejny identifikator v URL (publicId()). */
export const publicIdSchema = z
    .string()
    .min(6)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/, 'invalid_public_id');
/** ISO 8601 timestamp s casovym pasmem (vystup API vzdy UTC "Z" nebo offset). */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });
/** Penize jako numeric string - presnost nad Number.MAX_SAFE_INTEGER. */
export const moneyAmountSchema = z.string().regex(/^-?\d+(\.\d{1,12})?$/, 'invalid_money_amount');
/** ISO 4217 alpha-3. */
export const currencyCodeSchema = z
    .string()
    .length(3)
    .regex(/^[A-Z]+$/, 'invalid_currency_code');
export const moneySchema = z.object({
    amount: moneyAmountSchema,
    currency: currencyCodeSchema,
});
/** Jazyk je atribut kontextu (uzivatel/tenant/strana), nikdy globalni nastaveni. */
export const localeTagSchema = z.enum(['cs', 'en', 'de', 'pl']);
/** BCP-47 tag vstupujici z hlavicek/env (cs-CZ, en-US...). Normalizuje se na zakladni tag. */
export function normalizeLocaleTag(bcp47) {
    const base = bcp47.toLowerCase().split('-')[0];
    return base === 'en' || base === 'de' || base === 'pl' ? base : 'cs';
}
//# sourceMappingURL=primitives.js.map